import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import client from "../../../app/core/client-http/client";
import { endpoint } from "../../../utils/constants/endpoint";

export const doUploadImgNews = createAsyncThunk(
  "uploadImgNews/upload",
  async ({ url, file, type, thunkAPI }) => {
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": type,
      },
      body: file,
    });

    if (response.ok) {
      return thunkAPI.fulfillWithValue(response.data);
    } else {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const doSetImageNews = createAsyncThunk(
  "set-image",
  async (body, thunkAPI) => {
    const response = await client.post(
      endpoint.ADMIN_NEWS.NEWS + "/" + body.Id + "/setimage",
      body
    );
    if (response.ok) {
      return thunkAPI.fulfillWithValue(response.data);
    } else {
      return thunkAPI.rejectWithValue();
    }
  }
);

const initialState = {
  textEditorValue: "",
};

const newsSlice = createSlice({
  name: "news",
  initialState: initialState,
  reducers: {
    setTextEditorValue: (state, action) => {
      state.textEditorValue = action.payload;
    },
  },
});

export default newsSlice;
export const { actions, reducer } = newsSlice;
